import { Type } from "class-transformer";
import { EnaioGuiField } from "./EnaioGuiField";
import { EnaioObjectDefTranslation } from "./EnaioObjectDefTranslation";

export class EnaioGuiPage {
    name = "";
    internalName = "";
    iconId = 0;
    pos = 0;
    pageId = "";
    @Type(() => EnaioObjectDefTranslation)
    translatedNames: EnaioObjectDefTranslation[];
    @Type(() => EnaioGuiField)
    fields: EnaioGuiField[];
}
